import useStore from "../../../lib/itn-ui-kit/data/store";
import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../lib/itn-ui-kit/services/service-container";

import Template from "./template.jsx";

export default class ProvidersRoute extends BaseRoute {
  @service("repositories/provider-repository") providerRepository;

  element = (<Template />);

  async loader({ request }) {
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());
    const providers = await this.providerRepository.query(searchParams);
    const resultCount = useStore.getState().getTotalCount("provider");

    return {
      providers,
      resultCount,
    };
  }
}
